import { Link, useLocation } from "react-router-dom";

export default function EmployeeSidebar() {
    const { pathname } = useLocation();

    const linkClass = (path) =>
        `block px-4 py-2 rounded ${pathname.startsWith(path)
            ? "bg-green-600 text-white"
            : "text-gray-700 hover:bg-gray-200"
        }`;

    return (
        <div className="w-64 bg-gray-100 p-4 min-h-screen">
            <h2 className="text-xl font-bold mb-4">Employee Panel</h2>

            <nav className="space-y-2">
                <Link
                    to="/employee/dashboard"
                    className={linkClass("/employee/dashboard")}
                >
                    Dashboard
                </Link>

                <Link
                    to="/employee/legal-orders"
                    className={linkClass("/employee/legal-orders")}
                >
                    Legal Orders
                </Link>

                <Link
                    to="/employee/shipments"
                    className={linkClass("/employee/shipments")}
                >
                    Shipments
                </Link>

                <Link
                    to="/employee/invoices"
                    className={linkClass("/employee/invoices")}
                >
                    Invoices
                </Link>

                <Link
                    to="/employee/smart-delivery"
                    className={linkClass("/employee/smart-delivery")}
                >
                    Smart Delivery
                </Link>

                <Link
                    to="/employee/geofence"
                    className={linkClass("/employee/geofence")}
                >
                    GeoFence
                </Link>

                <Link
                    to="/employee/iot-devices"
                    className={linkClass("/employee/iot-devices")}
                >
                    IoT Devices
                </Link>
                <Link
                    to="/employee/demand-forecast"
                    className={linkClass("/employee/demand-forecast")}
                >
                    Demand Forecast
                </Link>

                <Link
                    to="/employee/sms"
                    className={linkClass("/employee/sms")}
                >
                    SMS Center
                </Link>

                <Link
                    to="/employee/digital-twin"
                    className={linkClass("/employee/digital-twin")}
                >
                    Digital Twin
                </Link>

                <Link
                    to="/employee/smart-contracts"
                    className={linkClass("/employee/smart-contracts")}
                >
                    Smart Contracts
                </Link>

                <Link
                    to="/employee/warehouses"
                    className={linkClass("/employee/warehouses")}
                >
                    Warehouses
                </Link>

                <Link
                    to="/employee/drivers"
                    className={linkClass("/employee/drivers")}
                >
                    Drivers
                </Link>

                <Link
                    to="/employee/dispatch-centers"
                    className={linkClass("/employee/dispatch-centers")}
                >
                    Dispatch Centers
                </Link>
                <Link
                    to="/employee/route-optimization"
                    className={linkClass("/employee/route-optimization")}
                >
                    Route Optimization
                </Link>

                <Link
                    to="/employee/movement"
                    className={linkClass("/employee/movement")}
                >
                    Movement Analytics
                </Link>

                <Link
                    to="/employee/delivery-routes"
                    className={linkClass("/employee/delivery-routes")}
                >
                    Delivery Routes
                </Link>

                <Link
                    to="/employee/delivery-history"
                    className={linkClass("/employee/delivery-history")}
                >
                    Delivery History
                </Link>

                <Link
                    to="/employee/delivery-price"
                    className={linkClass("/employee/delivery-price")}
                >
                    Delivery Price
                </Link>

                <Link
                    to="/employee/tracking-numbers"
                    className={linkClass("/employee/tracking-numbers")}
                >
                    Tracking Numbers
                </Link>
            </nav>
        </div>
    );
}